import { AnimatedIcon } from "./AnimatedIcon";

export const CustomStepIcon = ({
	statusHistories,
	currentStatus,
	...props
}) => {
	const { completed, icon } = props;
	const step = statusHistories[parseInt(icon) - 1] || {};
	const IconComponent = step.icon;

	return (
		<AnimatedIcon
			// animate={true}
			completed={completed}
			animate={currentStatus === parseInt(icon) - 1}
			type={step.animate_type}
			duration={step.duration}
		>
			<IconComponent stroke={2} size={24} />
		</AnimatedIcon>
	);
};
